// CurlImporterOverlay.jsx
import React from 'react';
import CurlImporter from './CurlImporter';
import styles from './APIConfigIndex.module.css';

export const CurlImporterOverlay = ({ 
  isOpen, 
  onClose, 
  onImport, 
  intentName,
  isConfigured,
  title = "Import cURL Configuration"
}) => {
  if (!isOpen) return null;

  // Handle click outside to close
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Handle escape key
  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  return (
    <div 
      className={styles.curlOverlay}
      onClick={handleOverlayClick}
    >
      <div className={styles.curlOverlayContent}>
        <div className={styles.curlOverlayHeader}>
          <h3 className={styles.curlOverlayTitle}>{title}</h3>
          <button 
            className={styles.curlOverlayClose}
            onClick={onClose}
            aria-label="Close cURL importer"
          >
            ✕
          </button>
        </div>
        <div className={styles.curlOverlayBody}>
          <CurlImporter
            onImport={(parsedConfig, sampleResponses, responseTemplateObj) => {
              onImport(parsedConfig, sampleResponses, responseTemplateObj);
              // Optionally auto-close after successful import
              // onClose();
            }}
            intentName={intentName}
            isConfigured={isConfigured}
          />
        </div>
      </div>
    </div>
  );
};